import { Context, CustomError } from '../index'
import {
  REPORT_LOADING_PROGRESS_EVENT_TYPE,
  CLOSE_LOADING_MODAL_EVENT_TYPE,
  REPORT_LEVEL_PASSED_EVENT_TYPE,
  AFTER_REPORT_LEVEL_PASSED_EVENT_TYPE,
  REPORT_CLEAR_GAME_EVENT_TYPE,
  AFTER_REPORT_CLEAR_GAME_EVENT_TYPE,
  REPORT_SOUND_STATUS_EVENT_TYPE,
  RESPONSE_CODE,
  LOGGER_PREFIX
} from '../constants'

export default class GameBase {
  private context: Context

  constructor(context: Context) {
    this.context = context
    const { pm } = context

    if (pm) {
      this.addEventListener()
    }
  }

  private addEventListener(): void {
    const { pm, provider } = this.context

    // 上报游戏加载进度
    pm.on(REPORT_LOADING_PROGRESS_EVENT_TYPE, ({ data }) => {
      provider.loadingProgress(data)
    })

    // 关闭游戏加载进度面板
    pm.on(CLOSE_LOADING_MODAL_EVENT_TYPE, () => {
      provider.hideLoading()
    })

    // 上报用户通过的关卡
    pm.on(REPORT_LEVEL_PASSED_EVENT_TYPE, async ({ data }) => {
      try {
        await this.reportLevelPassed(data)
        pm.emit(AFTER_REPORT_LEVEL_PASSED_EVENT_TYPE, {
          code: RESPONSE_CODE.SUCCESS
        })
      } catch (error) {
        pm.emit(AFTER_REPORT_LEVEL_PASSED_EVENT_TYPE, {
          code: error.code,
          error
        })
      }
    })

    // 上报用户通关
    pm.on(REPORT_CLEAR_GAME_EVENT_TYPE, () => {
      // TODO 参考REPORT_LEVEL_PASSED_EVENT_TYPE
      pm.emit(AFTER_REPORT_CLEAR_GAME_EVENT_TYPE, {
        code: RESPONSE_CODE.SUCCESS
      })
    })

    // 上报游戏声音开关状态
    pm.on(REPORT_SOUND_STATUS_EVENT_TYPE, ({ data }) => {
      const { status } = data
      console.log(`[${LOGGER_PREFIX}] got the sound status ${status}`)
    })
  }

  /**
   * 上报用户完成的游戏关卡
   * @param options
   */
  private async reportLevelPassed(
    options: ReportLevelPassedOptions
  ): Promise<boolean> {
    // TODO 后续功能调服务端上报用户完成的游戏关卡
    const error: CustomError = new Error('report level fail')
    error.code = RESPONSE_CODE.FAIL
    throw error
  }
}

type ReportLevelPassedOptions = {
  level: number
  levelTitle?: string
}
